import { PayloadAction } from '@reduxjs/toolkit'
import { fromJS } from 'immutable'
import { createReducer } from 'redux-immutablejs'

import {
  MANAGER_HUB_PROMOTION_SIGNAL_PROPERTY_NAME,
  parseManagerHubPromotionSignalPropertyValue,
} from '@lyrahealth-inc/shared-app-logic/src/features/managerHub/utils'
import { UserNotificationItem, UserObject } from '@lyrahealth-inc/shared-app-logic/src/models/user/User'

import {
  ADD_USER_CHILD,
  getEmployeeGroup,
  getGoogleCriticalTalentInfo,
  getSeatBasedLicenses,
  POST_GUARDIAN_INDICATED,
  postGoogleCriticalTalentInfo,
  putUserProperty,
  SET_HAS_PAST_FAVORITED_PROVIDERS,
  SET_USER_CHILD_INTERNATIONAL_CONSENT,
  SET_USER_CHILDREN,
  SET_USER_DEDICATED_CARE_NAVIGATOR_INFO,
  SET_USER_DIRECT_DEDICATED_CARE_NAVIGATOR_LINK,
  SET_USER_INFO,
  SET_USER_PHONE_NUMBER,
  SET_USER_REMAINING_TIME,
  submitPostMigrationConsent,
  TOGGLE_OFF_MFA,
  TOGGLE_ON_MFA,
  updateUserNotificationItem,
  verifyUserMFA,
} from './userActions'
import { POST_COUNTRY_INTERNATIONAL_CONSENT } from '../../common/http/data/country'
import {
  UPDATE_USER_COUNTRY,
  UPDATE_USER_DISPLAY_LANGUAGE,
  UPDATE_USER_TIMEZONE,
} from '../../features/editProfile/data/editProfileActions'
import { SAVE_MODALITY_PREFERENCE } from '../../features/onboard/modalityQuestionnaire/data/modalityQuestionnaireActions'

const initialState = fromJS({})

export default createReducer(initialState, {
  [SET_USER_INFO]: ($$state: $TSFixMe, action: $TSFixMe) => {
    $$state = $$state.mergeDeep(fromJS(action.data.user))
    return $$state
  },
  [UPDATE_USER_COUNTRY]: ($$state: $TSFixMe, action: PayloadAction<UserObject>) => {
    $$state = $$state.set('isInternational', fromJS(action.payload.user.isInternational))
    return $$state.set('customerCountries', fromJS(action.payload.user.customerCountries))
  },
  [TOGGLE_OFF_MFA]: ($$state: $TSFixMe, _action: $TSFixMe) => {
    $$state = $$state.set('mfa', false)
    return $$state
  },
  [TOGGLE_ON_MFA]: ($$state: $TSFixMe, _action: $TSFixMe) => {
    $$state = $$state.set('mfa', true)
    return $$state
  },
  [SAVE_MODALITY_PREFERENCE]: ($$state: $TSFixMe, action: $TSFixMe) => {
    return $$state.set('preferredAppointmentTypes', fromJS(action.modalityPreferences))
  },
  [POST_COUNTRY_INTERNATIONAL_CONSENT]: ($$state: $TSFixMe, action: $TSFixMe) => {
    return $$state.set('internationalConsent', fromJS(action.data.internationalConsent))
  },
  [UPDATE_USER_TIMEZONE]: ($$state: $TSFixMe, action: PayloadAction<UserObject>) => {
    return $$state.set('timeZone', fromJS(action.payload.user.timeZone))
  },
  [SET_USER_PHONE_NUMBER]: ($$state: $TSFixMe, action: PayloadAction<string>) => {
    return $$state.set('phone', fromJS(action.payload))
  },
  [SET_USER_DIRECT_DEDICATED_CARE_NAVIGATOR_LINK]: ($$state: $TSFixMe, action: $TSFixMe) => {
    return $$state.set('directDedicatedCareNavigatorLink', fromJS(action.data))
  },
  [SET_USER_CHILDREN]: ($$state: $TSFixMe, action: $TSFixMe) => {
    return $$state.set('children', fromJS(action.data))
  },
  [ADD_USER_CHILD]: ($$state: $TSFixMe, action: $TSFixMe) => {
    return $$state.update('children', ($$children: $TSFixMe) => {
      const children = $$children ?? fromJS([])
      const childIndex = children.findIndex((child: $TSFixMe) => child.get('lyraId') === action.data.lyraId)
      return childIndex === -1 ? children.push(fromJS(action.data)) : children.set(childIndex, fromJS(action.data))
    })
  },
  [SET_USER_CHILD_INTERNATIONAL_CONSENT]: ($$state: $TSFixMe, action: $TSFixMe) => {
    const { childLyraId, internationalConsent } = action.data
    return $$state.update('children', (children: $TSFixMe) =>
      children?.map((child: $TSFixMe) =>
        child.get('lyraId') === childLyraId ? child.set('internationalConsent', internationalConsent) : child,
      ),
    )
  },
  [SET_USER_REMAINING_TIME]: ($$state: $TSFixMe, action: $TSFixMe) => {
    return $$state.set('sessionRemainingTime', fromJS(action.data))
  },
  [UPDATE_USER_DISPLAY_LANGUAGE]: ($$state: $TSFixMe, action: $TSFixMe) => {
    return $$state.set('displayLanguage', action.payload.displayLanguage)
  },
  [POST_GUARDIAN_INDICATED]: ($$state: $TSFixMe) => {
    return $$state.set('hasIndicatedIsGuardian', true)
  },
  [SET_USER_DEDICATED_CARE_NAVIGATOR_INFO]: ($$state: $TSFixMe, action: $TSFixMe) => {
    return $$state.set('dedicatedCareNavigatorInfo', fromJS(action.data))
  },
  [getSeatBasedLicenses.pending.type]: ($$state: $TSFixMe) => {
    return $$state.set('seatBasedLicensesLoading', true).set('seatBasedLicensesError', false)
  },
  [getSeatBasedLicenses.fulfilled.type]: ($$state: $TSFixMe, action: PayloadAction<unknown>) => {
    return $$state
      .set('seatBasedLicenses', fromJS(action.payload))
      .set('seatBasedLicensesLoading', false)
      .set('seatBasedLicensesError', false)
  },
  [getSeatBasedLicenses.rejected.type]: ($$state: $TSFixMe) => {
    return $$state.set('seatBasedLicensesLoading', false).set('seatBasedLicensesError', true)
  },
  [updateUserNotificationItem.fulfilled.type]: ($$state: $TSFixMe, action: $TSFixMe) => {
    return $$state.set('notifications', fromJS(action.payload.notifications))
  },
  [updateUserNotificationItem.pending.type]: ($$state: $TSFixMe, action: $TSFixMe) => {
    return $$state.setIn(
      ['notifications', (action.meta.arg as UserNotificationItem)?.name],
      (action.meta.arg as UserNotificationItem)?.state,
    )
  },
  [SET_HAS_PAST_FAVORITED_PROVIDERS]: ($$state: Map<string, any>) => {
    return $$state.set('hasPastFavoritedProviders', true)
  },
  [postGoogleCriticalTalentInfo.fulfilled.type]: ($$state: $TSFixMe, action: $TSFixMe) => {
    if (action.meta?.arg?.isUserGoogleCriticalTalent !== undefined) {
      $$state = $$state.set('isUserGoogleCriticalTalent', action.meta?.arg?.isUserGoogleCriticalTalent)
    }
    return $$state
  },
  [getGoogleCriticalTalentInfo.fulfilled.type]: ($$state: $TSFixMe, action: $TSFixMe) => {
    const googleCriticalTalentInfo = action.payload
    return $$state.set('isUserGoogleCriticalTalent', googleCriticalTalentInfo?.isUserGoogleCriticalTalent)
  },
  [putUserProperty.fulfilled.type]: ($$state: $TSFixMe, action: any) => {
    if (action.payload.name === MANAGER_HUB_PROMOTION_SIGNAL_PROPERTY_NAME) {
      const timestamp =
        action.payload.classType === 'String'
          ? parseManagerHubPromotionSignalPropertyValue(action.payload.value)
          : undefined
      return timestamp == null ? $$state : $$state.setIn(['promotionSignals', 'managerHub'], timestamp)
    }
    return $$state.set(action.payload.name, action.payload.value)
  },
  [verifyUserMFA.fulfilled.type]: ($$state: Map<string, any>, action: any) => {
    return $$state.set('mfa', action.payload)
  },
  [getEmployeeGroup.fulfilled.type]: ($$state: $TSFixMe, action: $TSFixMe) => {
    return $$state.set('employeeGroup', action.payload.employeeGroup ? action.payload.employeeGroup : null)
  },
  [getEmployeeGroup.rejected.type]: ($$state: $TSFixMe) => {
    return $$state.set('employeeGroup', null)
  },
  [submitPostMigrationConsent.fulfilled.type]: ($$state: $TSFixMe, action: $TSFixMe) => {
    return $$state.mergeDeep(fromJS(action.payload))
  },
})
